"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingFieldInManifestUserError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "InvalidFieldInManifest";
const messageKey = "driver.aadApp.error.invalidFieldInManifest"; // Field %s is missing or invalid in Microsoft Entra app manifest.
class MissingFieldInManifestUserError extends teamsfx_api_1.UserError {
    constructor(actionName, missingFields, helpLink) {
        let fieldList;
        if (Array.isArray(missingFields)) {
            fieldList = missingFields.join(", ");
        }
        else {
            fieldList = missingFields;
        }
        super({
            source: actionName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey, fieldList),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey, fieldList),
            helpLink: helpLink,
        });
    }
}
exports.MissingFieldInManifestUserError = MissingFieldInManifestUserError;
//# sourceMappingURL=invalidFieldInManifestError.js.map